import React, { useState, useContext } from 'react';
import { AuthContext } from '../../context/AuthContext';
import UploadManager from '../../components/admin/UploadManager';

export default function AdminUploadsPage() {
  const { token } = useContext(AuthContext);
  const [uploadedUrls, setUploadedUrls] = useState([]);

  return (
    <div className="container-fluid py-4">
      <h2 className="brand-font mb-4">Host API Upload Manager</h2>
      <p className="text-muted small">
        Direct image upload manager integrated with Host API.
        Select or drag and drop image files to upload, reorder, replace, or select from existing asset gallery.
      </p>

      <div className="p-4 border rounded bg-card shadow-sm">
        <UploadManager
          images={uploadedUrls}
          onImagesChange={setUploadedUrls}
          token={token}
          label="Standalone Image Upload Manager"
        />
      </div>
    </div>
  );
}
